// extracted by mini-css-extract-plugin
export default {"introduction":"style_introduction__6MyQB","backgroundImage":"style_backgroundImage__r9BKO"};